import { InformationQuery } from '@/api-client/models/shared/Contracts'
import { getRequestGateway } from './api.service'
import { InformationResponse } from '@/api-client/models/indoorclimate/Contracts'

export async function getIotCoverage(query: InformationQuery): Promise<InformationResponse> {
  const urlQuery = encodeURIComponent(JSON.stringify(query))
  const res = await getRequestGateway<InformationResponse>(
    `/iot/v1/coverage?query=${urlQuery}`,
    5000,
    3
  )
  return res.data
}
